(function () {
  var EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function getSuccessMessage(form) {
    var section = form.closest('.newsletter-section');
    return (section && section.dataset.nlSuccess) || '¡Gracias por suscribirte!';
  }

  function renderSuccess(form) {
    var msg = getSuccessMessage(form);

    var wrapper = document.createElement('div');
    wrapper.className = 'newsletter-form__success';
    wrapper.setAttribute('role', 'status');
    wrapper.setAttribute('aria-live', 'polite');

    var p = document.createElement('p');
    p.className = 'newsletter-form__message newsletter-form__message--success';
    p.textContent = msg;

    wrapper.appendChild(p);
    form.innerHTML = '';
    form.appendChild(wrapper);
  }

  function bindForm(form) {
    if (form.dataset.nlBound === '1') return;
    form.dataset.nlBound = '1';

    if (form.action) {
      try { form.action = form.action.split('#')[0]; } catch (err) {}
    }

    var input = form.querySelector('.newsletter-form__input');
    var button = form.querySelector('.newsletter-form__button');

    function restoreButton() {
      if (!button) return;
      button.disabled = false;
      if (button.dataset.originalText) {
        button.textContent = button.dataset.originalText;
        delete button.dataset.originalText;
      }
    }

    function showInlineError(msg) {
      var live = form.querySelector('.newsletter-form__live');
      var existing = form.querySelector('.newsletter-form__message--client');
      if (existing) existing.remove();
      var p = document.createElement('p');
      p.className = 'newsletter-form__message newsletter-form__message--error newsletter-form__message--client';
      p.setAttribute('role', 'alert');
      p.textContent = msg;
      (live || form).appendChild(p);
    }

    function clearInlineError() {
      var existing = form.querySelector('.newsletter-form__message--client');
      if (existing) existing.remove();
      if (input) input.setAttribute('aria-invalid', 'false');
    }

    if (input) {
      input.addEventListener('input', clearInlineError);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }

      if (form.dataset.nlSent === '1') return;

      var hp = form.querySelector('input[name="contact[website]"]');
      if (hp && hp.value) return;

      var value = input ? input.value.trim() : '';
      if (!EMAIL_RX.test(value)) {
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        }
        showInlineError('Ingresá un email válido.');
        return;
      }

      clearInlineError();

      if (button) {
        button.disabled = true;
        if (!button.dataset.originalText) {
          button.dataset.originalText = button.textContent;
        }
        button.textContent = 'Enviando...';
      }

      var formData = new FormData(form);
      if (!formData.get('form_type')) formData.append('form_type', 'customer');
      if (!formData.get('utf8')) formData.append('utf8', '✓');


      var action = (form.action || '/contact').split('#')[0];

      fetch(action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'text/html, application/xhtml+xml' },
        credentials: 'same-origin',
        redirect: 'manual'
      })
        .then(function () {
          form.dataset.nlSent = '1';
          renderSuccess(form);
        })
        .catch(function () {
          restoreButton();
          showInlineError('No pudimos enviar tu suscripción. Probá de nuevo en unos segundos.');
        });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.newsletter-form').forEach(bindForm);
  }

  init();

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('.newsletter-form').forEach(function (f) {
      f.dataset.nlBound = '';
    });
    init(section);
  });
})();
